"use client";
import Image from "next/image";
import Link from "next/link";
import SocmedComp from "./socmed.comp";

const FooterComp = ({ menu, socmed }: { menu: any[]; socmed: any }) => {
  return (
    <footer className="bg-[#F0F6F3]">
      <div className="bg-gradient-to-r from-accent to-green h-2"></div>
      <div className="container mx-auto space-y-8 px-4 sm:px-6 lg:space-y-16 lg:px-8 pt-16 pb-4">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-3">
          <div>
            <div className="text-teal-600">
              <Image
                src="/images/logo.png"
                alt="Kementerian Kehutanan"
                width={160}
                height={32}
              />
            </div>
            <p className="mt-4 max-w-xs text-gray-500">
              Gedung Manggala Wanabakti Blok I lt. 2, Jl. Jenderal Gatot Subroto
              - Jakarta 10270, Po Box 6505, Indonesia.
            </p>
            <p className="mt-2 text-sm text-gray-500">
              pusdatin@menlhk.go.id | ppid@menlhk.go.id
            </p>
          </div>

          <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:col-span-2 lg:grid-cols-3">
            {menu.map((fm) => (
              <div key={fm.name}>
                <p className="font-medium text-dark">{fm.name}</p>
                <ul className="mt-6 space-y-4 text-sm">
                  {fm.childs.map((sfm: any) => (
                    <li key={sfm.name}>
                      <Link
                        href={sfm.href}
                        className="text-gray-700 transition hover:opacity-75"
                      >
                        {sfm.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
            <div>
              <p className="font-medium text-dark">Sosial Media</p>
              <div className="mt-6 space-y-4 text-sm">
                <SocmedComp
                  instagramLink={socmed.instagram}
                  facebookLink={socmed.facebook}
                  xtwitterLink={socmed.twitter}
                  youtubeLink={socmed.youtube}
                />
              </div>
            </div>
          </div>
        </div>

        <p className="text-xs text-gray-500 border-t border-solid border-gray-300 pt-4 text-center">
          Copyright &copy; 2025, Kementerian Kehutanan
        </p>
      </div>
    </footer>
  );
};

export default FooterComp;
